import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';

import Header from '../Header';
import useLocalStorage from '../../hooks/useLocalStorage';
import { ModalContext } from '../../context';

import settings from '../../config';
import { format } from '../../utils';
import editIcon from '../../imgs/edit.png';
import deleteIcon from '../../imgs/delete.png';

const FabricVariantTransactions = () => {
  const [productionAssetVariants, setFabricInstalments] = useState([]);
  const { productionAssetId } = useParams();
  const [admin] = useLocalStorage('admin');
  const [, setModal] = useContext(ModalContext);

  useEffect(() => {
    (async () => {
      const response = await axios.post(
        `${settings.api}production-assets/variant-transactions`,
        {
          productionAssetId
        }
      );

      if (response.data.statusCode === 200) {
        setFabricInstalments(response.data.data);
      }
    })();
  }, [productionAssetId]);

  const deleteProductInstalment = async (productionAssetVariantId) => {
    setModal({
      isModalOpen: true,
      modalAction: async () => {
        const response = await axios.post(
          `${settings.api}production-assets/delete-variant-transaction`,
          {
            productionAssetVariantId
          }
        );

        if (response.data.statusCode === 200) {
          setFabricInstalments(
            productionAssetVariants.filter(
              (productionAssetVariant) =>
                productionAssetVariantId !==
                productionAssetVariant.productionAssetTransactionVariantId
            )
          );
        }
      }
    });
  };

  return (
    <div className='w-full'>
      <Header
        text='اضافه منتجات'
        link={`/production-asset/variant/form/${productionAssetId}`}
      />
      <table className='w-full table-auto border-separate border-spacing-1 text-right '>
        <thead>
          <tr>
            <th>كود المنتج</th>
            <th>اسم المنتج</th>
            <th>التكلفه</th>
            <th>تاريخ الدفعه</th>
            {admin.canEdit === 1 && <th className='text-center w-24'>تعديل</th>}
            {admin.canDelete === 1 && <th className='text-center w-24'>حذف</th>}
          </tr>
        </thead>
        <tbody>
          {productionAssetVariants.map((productionAssetVariant) => {
            return (
              <tr
                key={productionAssetVariant.productionAssetTransactionVariantId}
                className='bg-white odd:bg-gray-100 hover:bg-orange-100'
              >
                <td>{productionAssetVariant.variantCode}</td>
                <td>{productionAssetVariant.variantName}</td>
                <td className='text-center'>
                  {format(productionAssetVariant.price || 0)}
                </td>
                <td>{productionAssetVariant.processingDate}</td>
                {admin.canEdit === 1 && (
                  <td className='text-center'>
                    <Link
                      to={`/production-asset/variant/form/${productionAssetId}/${productionAssetVariant.productionAssetTransactionVariantId}`}
                      className='flex flex-col items-center w-full cursor-pointer'
                    >
                      <img src={editIcon} alt='edit' className='h-10' />
                    </Link>
                  </td>
                )}
                {admin.canDelete === 1 && (
                  <td className='text-center'>
                    <div
                      className='flex flex-col items-center w-full cursor-pointer'
                      onClick={() =>
                        deleteProductInstalment(
                          productionAssetVariant.productionAssetTransactionVariantId
                        )
                      }
                    >
                      <img src={deleteIcon} alt='delete' className='h-5' />
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FabricVariantTransactions;
